@if (enableSearchInput) {
  <div class="mb-2 relative" [formGroup]="searchForm">
    <input
      type="text"
      class="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-black focus:border-transparent transition-all duration-200 placeholder:text-gray-400"
      [placeholder]="inputPlaceholder | translate"
      formControlName="searchTerm"
      [disabled]="isSearching"
    />
    <app-contacts-autocomplete
      [query]="searchForm.get('searchTerm')?.value || ''"
      (selectContact)="onSelectContact($event)"
      class="absolute left-0 top-full w-full z-20"
    ></app-contacts-autocomplete>
  </div>
}

@if (targetUser || userEmail) {
  <div
    class="relative flex items-center gap-2 w-full {{
      targetUser ? 'custom-gradient-bg  py-[1px] px-2' : 'bg-none p-0'
    }} border border-gray-200 rounded-lg shadow-sm"
  >
    @if (!hideClearButton) {
      <!-- Close button -->
      <app-nicky-button
        [variant]="'text'"
        [iconLeft]="'ph ph-x'"
        class="absolute -top-2 -right-2 bg-gray-200 hover:bg-gray-300 text-gray-700 rounded-full w-6 h-6 text-base flex items-center justify-center shadow-md z-10"
        (click)="onClearUser.emit()"
      >
      </app-nicky-button>
    }

    @if (isLoadingDebounced$ | async) {
      <div class="flex items-center gap-2 w-full min-h-[46px]">
        <div class="animate-pulse flex items-center gap-2 w-full">
          <div class="size-10 rounded-full bg-gray-200 shrink-0"></div>
          <div class="h-4 bg-gray-200 rounded w-3/4"></div>
        </div>
      </div>
    } @else if (targetUser) {
      <div class="flex items-center gap-2 w-full cursor-pointer min-h-[46px]" (click)="clickHandler()">
        <app-user-profile-picture
          [imageUrl]="targetUser?.profileImageUrl"
          [name]="targetUser?.publicName || ''"
          [size]="'sm'"
          [className]="'size-10 rounded-full'"
          class="shrink-0"
        ></app-user-profile-picture>
        <span class="truncate flex-1 font-medium text-[#202B42]">{{ targetUser?.publicName }}</span>
      </div>
    } @else if (userEmail && !(isLoadingDebounced$ | async)) {
      <span
        class="truncate flex-1 font-medium text-[#202B42] bg-[#EFF0F4] rounded px-2 py-1 cursor-pointer min-h-[46px] flex items-center"
        (click)="clickHandler()"
      >
        <i class="ph ph-user text-gray-400 mr-2"></i>
        <span class="truncate">{{ userEmail }}</span>
      </span>
    }
  </div>
}

@if (showTargetInfo) {
  <app-payer-info-tooltip
    [payerEmail]="userEmail || ''"
    [payerName]="payerName"
    [targetUser]="targetUser"
    [absolute]="true"
    (close)="showTargetInfo = false"
    (editName)="editInfo.emit()"
  >
  </app-payer-info-tooltip>
}
